export default {

    // check if object is empty
    isEmpty(item) {
        return typeof item == 'undefined' || item === null || item === ""
    },

    // Prepare params for you that will be use on the request
    prepareParams(options, search = '') {
        const { sortBy, sortDesc, page, itemsPerPage } = options
        return {
            page: page,
            limit: itemsPerPage,
            sortBy: sortBy ? sortBy[0] : null,
            sortDesc: sortDesc ? sortDesc[0] : null,
            search: search,
        }
    },

    // Handle errors and return all errors in a string
    getErrors(error) {

        if (!error || typeof error.response == 'undefined') {
            console.error('[ERROR] an error occured unexpectedly : ', error)
            return 'Unexpected Error Occured. Please try again.';
        }

        let errors = [];
        let errResponse = error.response;
        console.log('[ERROR] response', errResponse);

        // check for unauthenticed request, redirect to login
        if (
            errResponse.data &&
            errResponse.data.status_code == 500 &&
            errResponse.data.message == "Unauthenticated."
        ) {
            localStorage.removeItem('jwt');
            const currentUrl = window.location.href;
            window.location.href = '/login?refs=' + encodeURIComponent(currentUrl);
            return 'Need to login again.';
        }


        // check if error has response and data errors
        if (errResponse && errResponse.data && errResponse.data.errors) {
            errors = [];
            let errItems = errResponse.data.errors;
            // iterate error items
            for (const index in errItems) {
                // checks if an item has more errors
                if (typeof errItems[index] === 'Array') {
                    errors.push(errItems[index].join(', '));
                } else {
                    // otherwise just push
                    errors.push(errItems[index]);
                }
            }
        } else if (Array.isArray(errResponse.data)) {
            errResponse.data.forEach(err => {
                if (Array.isArray(err)) {
                    errors.push(err.join(', '));
                } else {
                    errors.push(err);
                }
            });
        } else if (errResponse.data.message) {
            errors.push(errResponse.data.message);
        } else if (errResponse.statusText) {
            errors.push(errResponse.statusText)
        } else {
            console.log('[ERROR] is : ', error)
        }

        if (errors.length <= 0) {
            errors.push("There seems to be an error!");
        }

        return errors.join(', ');
    },

    // This helper function will change the url without refreshing page
    pushState(url, params) {
        let newParams = Object.keys(params)
            .map(key => {
                return (encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
            })
        let newUrl = url + '?' + newParams.join('&')

        history.pushState(params, null, newUrl)
    },


    // Status chip background per MachShip palette:
    // White by default; Blue soft for success/complete/done; Orange soft for fail/error.
    getColor(status) {
        if (!status) return '#FFFFFF' // White (default)

        switch (status.toLowerCase()) {
            case 'machship_error':
            case 'fail':
            case 'failed':
            case 'error':
            case 'errors':
                return '#FFF8F5' // MachShip Orange soft
            case 'active':
            case 'success':
            case 'complete':
            case 'completed':
            case 'done':
                return '#F2F3FF' // MachShip Blue soft
            default:
                return '#FFFFFF' // White (default)
        }
    },

    // Chip text colour. All chip backgrounds (White / Blue soft / Orange soft)
    // are light, so status chip text is always dark.
    getTextColor(status) {
        return '#00073C' // MachShip Midnight Blue
    },

    // Chip border colour, matched to each palette (like the brand colour swatches).
    getBorderColor(status) {
        if (!status) return '#DEDEDE' // grey (White default)
        switch (status.toLowerCase()) {
            case 'machship_error':
            case 'fail':
            case 'failed':
            case 'error':
            case 'errors':
                return '#FF7033' // Earth Orange (Orange soft)
            case 'active':
            case 'success':
            case 'complete':
            case 'completed':
            case 'done':
                return '#004AAD' // Sky Blue (Blue soft)
            default:
                return '#DEDEDE' // grey (White default)
        }
    },

    // Record Status chip fill: Sky Blue default, Orange Dark error,
    // Gray Soft skipped, Blue Soft completed.
    recordStatusColor(status) {
        switch (status ? String(status).toLowerCase() : '') {
            case 'machship_error':
            case 'fail':
            case 'failed':
            case 'error':
            case 'errors':
                return '#7E2501' // MachShip Orange Dark
            case 'skip':
            case 'skipped':
                return '#EFEFEF' // MachShip Gray Soft
            case 'complete':
            case 'completed':
            case 'done':
                return '#F2F3FF' // MachShip Blue Soft
            default:
                return '#004AAD' // MachShip Sky Blue (default)
        }
    },

    // Record Status chip text: dark on the light fills (skipped/completed), else white.
    recordStatusTextColor(status) {
        switch (status ? String(status).toLowerCase() : '') {
            case 'skip':
            case 'skipped':
            case 'complete':
            case 'completed':
            case 'done':
                return '#00073C' // MachShip Midnight Blue
            default:
                return 'white'
        }
    },

    // Record Status chip border, matched to its fill / palette.
    recordStatusBorderColor(status) {
        switch (status ? String(status).toLowerCase() : '') {
            case 'machship_error':
            case 'fail':
            case 'failed':
            case 'error':
            case 'errors':
                return '#7E2501' // Orange Dark
            case 'skip':
            case 'skipped':
                return '#DEDEDE' // grey
            default:
                return '#004AAD' // Sky Blue (also Blue soft border for completed)
        }
    },

    // Live rate log Status chip fill: Orange Dark for fail, Blue Soft for
    // success, White otherwise.
    liveRateStatusColor(status) {
        switch (status ? String(status).toLowerCase() : '') {
            case 'fail':
            case 'failed':
            case 'error':
            case 'machship_error':
                return '#7E2501' // MachShip Orange Dark
            case 'success':
            case 'complete':
            case 'completed':
            case 'done':
                return '#F2F3FF' // MachShip Blue Soft
            case 'fallback':
                return '#FFF8F5' // MachShip Orange Soft
            default:
                return '#FFFFFF' // White
        }
    },

    liveRateStatusTextColor(status) {
        switch (status ? String(status).toLowerCase() : '') {
            case 'fail':
            case 'failed':
            case 'error':
            case 'machship_error':
                return 'white' // dark fill
            default:
                return '#00073C' // light fills
        }
    },

    liveRateStatusBorderColor(status) {
        switch (status ? String(status).toLowerCase() : '') {
            case 'fail':
            case 'failed':
            case 'error':
            case 'machship_error':
                return '#7E2501' // Orange Dark
            case 'success':
            case 'complete':
            case 'completed':
            case 'done':
                return '#004AAD' // Sky Blue (Blue soft border)
            case 'fallback':
                return '#FF7033' // Earth Orange (Orange soft border)
            default:
                return '#DEDEDE' // grey (White)
        }
    },

    // --- MachShip status pill helpers (contact_us / embedded ecommerce app) ---
    // Soft-pill palette: light fill + 1px matched border + dark text.
    // getColor stays as-is above (used by the internal admin app); these are
    // additive and only consumed by the contact_us log/status chips.

    // Generic status chip fill: White default; Blue soft for success/complete;
    // Orange soft for fail/error.
    chipBg(status) {
        if (!status) return '#FFFFFF' // White (default)
        switch (status.toLowerCase()) {
            case 'machship_error':
            case 'fail':
            case 'failed':
            case 'error':
            case 'errors':
                return '#FFF8F5' // MachShip Orange soft
            case 'active':
            case 'success':
            case 'complete':
            case 'completed':
            case 'done':
                return '#F2F3FF' // MachShip Blue soft
            default:
                return '#FFFFFF' // White (default)
        }
    },

    // this is where we set pagination options
    getPaginateOptions(perPage = 50) {
        return {
            page: 1,
            itemsPerPage: perPage,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: [],
            mustSort: false,
            multiSort: false,
        }
    },

    parseResponse(response) {
        return response?.data?.map(
            d => Object.assign(d.attributes, {id: d.id})
        )
    }

}